import { produce } from 'immer';

const VAT_AMOUNT = 0.2;

/*STATE*/
type SubscribeState = {
  preTaxPrice: number;
  vat: number;
  totalPrice: number;
};

const initialState: SubscribeState = {
  preTaxPrice: 0,
  vat: 0,
  totalPrice: 0,
};

// Reducer
enum SubscribeActionType {
  SET_TOTAL_PRICE = 'app/subscribe/SET_TOTAL_PRICE',
}

type SubscribeAction = {
  type: SubscribeActionType.SET_TOTAL_PRICE;
  payload: { preTaxPrice: number };
};

export const subscribe = (
  state = initialState,
  action: SubscribeAction
): SubscribeState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case SubscribeActionType.SET_TOTAL_PRICE:
        draft.preTaxPrice = action.payload.preTaxPrice;
        draft.vat = action.payload.preTaxPrice * VAT_AMOUNT;
        draft.totalPrice = draft.preTaxPrice + draft.vat;
        break;
    }
  });
};

// Action creators
export const setPreTaxPrice = (preTaxPrice: number) => ({
  type: SubscribeActionType.SET_TOTAL_PRICE,
  payload: { preTaxPrice },
});
